import { useEffect } from "react";

const useDecimalGuard = () => {
  useEffect(() => {
    const handleKeyDown = (e: KeyboardEvent) => {
      if (e.key !== ",") return;

      const target = e.target as HTMLInputElement;
      if (target.tagName !== "INPUT" && target.tagName !== "TEXTAREA") return;
      if (target.dataset.noDecimalGuard !== undefined) return;

      e.preventDefault();

      const start = target.selectionStart ?? target.value.length;
      const end = target.selectionEnd ?? target.value.length;
      const newValue =
        target.value.slice(0, start) + "." + target.value.slice(end);

      const nativeInputValueSetter = Object.getOwnPropertyDescriptor(
        window.HTMLInputElement.prototype,
        "value"
      )?.set;
      nativeInputValueSetter?.call(target, newValue);
      target.dispatchEvent(new Event("input", { bubbles: true }));
      target.setSelectionRange(start + 1, start + 1);
    };

    const handlePaste = (e: ClipboardEvent) => {
      const target = e.target as HTMLInputElement;
      if (target.tagName !== "INPUT" && target.tagName !== "TEXTAREA") return;
      if (target.dataset.noDecimalGuard !== undefined) return;

      const pasted = e.clipboardData?.getData("text") ?? "";
      if (!pasted.includes(",")) return;

      e.preventDefault();
      const sanitized = pasted.replace(/,/g, ".");

      const nativeInputValueSetter = Object.getOwnPropertyDescriptor(
        window.HTMLInputElement.prototype,
        "value"
      )?.set;
      nativeInputValueSetter?.call(target, sanitized);
      target.dispatchEvent(new Event("input", { bubbles: true }));
    };

    document.addEventListener("keydown", handleKeyDown, true);
    document.addEventListener("paste", handlePaste, true);

    return () => {
      document.removeEventListener("keydown", handleKeyDown, true);
      document.removeEventListener("paste", handlePaste, true);
    };
  }, []);
};

export default useDecimalGuard;
